<div class="cancel-order-dialog">
  <h2 mat-dialog-title>{{ data.isBulk ? ('orders.cancelOrderDialog.bulkTitle' | translate) : ('orders.cancelOrderDialog.title' | translate) }}</h2>

  <mat-dialog-content>
    <div class="messages">
      <txp-message
        *ngIf="data.showPartialSuccessInfo && successfulOrderIds.length"
        [type]="messageType.SUCCESS"
        [dismissible]="true">
        {{ 'orders.orderInfo.cancelOrderSuccessMsg' | translate }}
      </txp-message>
      <txp-message
        *ngIf="showError"
        [type]="messageType.DANGER"
        [dismissible]="true"
        (dismiss)="dismissError()">
        {{ errorSummaryKey | translate }}
      </txp-message>
    </div>

    <p class="confirmation-message">
      {{ (data.isBulk && confirmationCount > 1) ? ('orders.cancelOrderDialog.bulkMessage' | translate: { count: confirmationCount }) : ('orders.cancelOrderDialog.message' | translate) }}
    </p>

    <form [formGroup]="cancelForm" class="cancel-form">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Cancel Reason</mat-label>
        <mat-select formControlName="cancellationReason" required>
          <mat-option *ngFor="let reason of availableReasons" [value]="reason.value">
            {{ reason.label }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="cancelForm.get('cancellationReason')?.hasError('required')">
          {{ 'orders.cancelOrderDialog.cancelReasonRequired' | translate }}
        </mat-error>
      </mat-form-field>
    </form>

    <div *ngIf="hasFailedOrdersTable" class="failed-orders-table">
      <div>{{ 'orders.cancelOrderDialog.failedCancelRequestsTitle' | translate }}</div>
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'orders.cancelOrderDialog.failedOrderIdHeader' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let failedOrderId of failedOrderIds">
            <td>{{ failedOrderId }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <txp-button
      [style]="buttonStyle.SECONDARY"
      (click)="onCancel()"
      [disabled]="isLoading">
      {{ 'form.button.cancel' | translate }}
    </txp-button>
    <txp-button
      [style]="buttonStyle.PRIMARY"
      (click)="onConfirm()"
      [disabled]="isConfirmDisabled"
      [loading]="isLoading">
      {{ confirmButtonLabelKey | translate }}
    </txp-button>
  </mat-dialog-actions>
</div>